//img-Intersection-observer.js

document.addEventListener("DOMContentLoaded", function() {
  const lcpImage = document.querySelector('.lazy-lcp');
  if (lcpImage) {
    lcpImage.src = lcpImage.dataset.src || lcpImage.src;
  }
  
  const images = document.querySelectorAll('.lazy');
  const imageOptions = {
    rootMargin: '0px 0px 200px 0px', // 화면 아래로부터 200px 정도까지 로드
    threshold: 0.1 // 이미지가 10% 보여졌을 때 로드
  };
  
  const loadImage = (image) => {
    const src = image.getAttribute('data-src');
    if (src) {
      image.src = src;
      image.classList.remove('lazy'); // 이미지를 로딩 후 lazy 클래스 제거
    }
  };
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadImage(entry.target);  // 이미지를 로드
        observer.unobserve(entry.target); // 더 이상 감지하지 않도록 함
      }
    });
  }, imageOptions);
  
  images.forEach(image => {
    imageObserver.observe(image); // 모든 lazy 이미지에 대해 관찰 시작
  });
});